import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Intake from "./pages/Intake";
import Complaint from "./pages/Complaint";
import Mode from "./pages/Mode";
import Capture from "./pages/Capture";
import Upload from "./pages/Upload";
import Processing from "./pages/Processing";
import Report from "./pages/Report";
import Chat from "./pages/Chat";
import Admin from "./pages/Admin";
import Control from "./pages/Control";
import QR from "./pages/QR";
import Xray from "./pages/Xray";
import AddXray from "./pages/AddXray";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/intake" element={<Intake />} />
        <Route path="/complaint" element={<Complaint />} />
        <Route path="/mode" element={<Mode />} />
        <Route path="/capture" element={<Capture />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/processing" element={<Processing />} />
        <Route path="/report" element={<Report />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/control" element={<Control />} />
        <Route path="/qr" element={<QR />} />
        <Route path="/xray" element={<Xray />} />
        <Route path="/addxray" element={<AddXray />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
